// Theme config — swap accent by changing THEME to 'yellow' or 'blue'.
// The CSS variables in index.css react automatically via [data-theme].
export const THEME = "yellow"; // 'yellow' | 'blue'
